import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import ApproversModal from 'component/punctualAdjustApprovers/ApproversModal'
import SuccessModal from '../Modal/SuccessModal'
import ExclusionModal from '../ExclusionModal/ExclusionModal'

const REMOVE = 'MISSION_REMOVE'
let modalType = REMOVE

class PunctualAdjustApproversTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      menuMissionsSelected: [],
      menuMissionsSelectedIndex: [],
      lastApproversSelected: null,
      approversModal: false,
      totalSelected: 0,
      presentDelSuccess: false,
    }
  }

  openRemoveModal = () => {
    modalType = REMOVE
    this.toggleApproversModal()
  }

  toggleApproversModal = () => {
    this.setState({ approversModal: !this.state.approversModal })
  }

  renderApproversModal = () => {
    const { approversModal } = this.state
    const { translate } = this.props

    if (!approversModal) {
      return
    }

    let props = {}
    if (modalType === REMOVE) {
      props = {
        modalType: REMOVE,
        translate,
        closeModal: this.toggleApproversModal,
        onSubmit: this.handleDelete,
      }
    }

    return <ApproversModal {...props} />
  }

  handleDelete = () => {
    const { delMenuMission } = this.props
    const { lastApproversSelected } = this.state

    delMenuMission(lastApproversSelected, this.onDelSuccess)
  }

  onDelSuccess = () => {
    this.setState({ presentDelSuccess: true })
  }

  handleRemove = (value) => {
    this.setState({ lastApproversSelected: value }, () => {
      this.handleDelete()
    })
  }

  openViewModal = () => {
    modalType = REMOVE
    this.toogleApproversModal()
  }

  toogleApproversModal = () => {
    this.setState({ approversModal: !this.state.approversModal })
  }

  renderRows = (menuMission, index) => {
    const { translate } = this.props

    return (
      <tr key={index}>
        <td className='align-left overflow-hidden-column'>
          {menuMission.dsMission}
        </td>
        <td className='align-right'>
          <ExclusionModal
            t={translate}
            title={translate('punctual.adj.approvers.remove.perm')}
            message={
              <>
                <br />
                {translate('punctual.adj.approvers.wanna.remove.perm')}
                <br />
                <b> {menuMission.dsMission} </b>
              </>
            }
            confirmButtonMsg='approvers.remove.confirm'
            onConfirm={() => this.handleRemove(menuMission)}
            renderButton={({ onClick }) => (
              <a
                className='trash-icon-padding'
                id={`view-mission-${index}`}
                role='button'
                onClick={onClick}
              >
                <i className='color-danger glyph glyph-trash-can icon-size' />
              </a>
            )}
          />
        </td>
      </tr>
    )
  }

  render() {
    const { menuMissions, translate, renderButtons } = this.props

    const { presentDelSuccess } = this.state

    return (
      <div className='ApproversTable'>
        {presentDelSuccess && (
          <SuccessModal
            t={translate}
            handleClose={() => this.setState({ presentDelSuccess: false })}
            size='md'
            msg={translate('punctual.adj.approvers.permission.remove.success')}
          />
        )}
        {renderButtons && (
          <Row className='margin-top-double margin-bottom width-100'>
            <Col xs={12} sm={12} md={12} lg={12} className='margin-bottom'>
              <div className='display-inline'>
                <span>
                  {`${this.state.totalSelected} ${translate(
                    'punctual-adjust-approvers.added-mission-list'
                  )}  |  `}
                </span>

                <span>{'  |  '}</span>
              </div>
            </Col>

            <Col xs={12} md={3} className='float-right'>
              <button
                role='button'
                onClick={this.openRemoveModal}
                className='button button-danger button-full align-center'
              >
                {translate('option.removeSelected')}
              </button>
            </Col>
          </Row>
        )}

        <table cellPadding={0} cellSpacing={0} className='new-table'>
          <thead>
            <tr>
              <th>{translate('punctual-adjust-approvers.mission')}</th>
              <th className='text-right'>
                {translate('punctual-adjust-approvers.mission.remove')}
              </th>
            </tr>
          </thead>
          <tbody>{menuMissions.map(this.renderRows)}</tbody>
        </table>
        {this.renderApproversModal()}
      </div>
    )
  }
}

PunctualAdjustApproversTable.propTypes = {
  menuMissions: PropTypes.array.isRequired,
  translate: PropTypes.func.isRequired,
  delMenuMission: PropTypes.func.isRequired,
  renderButtons: PropTypes.bool.isRequired,
  setRenderButtons: PropTypes.func.isRequired,
}

export default PunctualAdjustApproversTable
